<template>
    <div>
        <MenuAdmin/>
    </div>
</template>
<script>
import MenuAdmin from '../diagnostico/admin/MenuAdmin.vue'
export default{
   components:{
     MenuAdmin
   },   
   data(){
    return{

    }
   }
}
</script>